import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/hooks';
import { LANGUAGE_NAME, LANGUAGES, type Language } from '@/i18n';
import { Dropdown } from './Dropdown';

const OPTIONS = LANGUAGES.map((value) => ({ value, label: LANGUAGE_NAME[value] }));

/** Language dropdown; each language is named in itself (Magyar, Srpski, English, Norsk). */
export function LanguageSwitch({ onChange }: { onChange: (lang: Language) => void }) {
  const { t } = useTranslation();
  const lang = useLanguage();
  return (
    <Dropdown
      variant="compact"
      ariaLabel={t('common.language')}
      value={lang}
      options={OPTIONS}
      // Dropdown reports only a real change, like the old segmented control did.
      onChange={onChange}
    />
  );
}
